import React, { useEffect, useState } from "react";
import { Styles } from "./styles";
import { useNavigate, useParams } from "react-router-dom";
import ChatComponent from "./chat-component";
import { Box, CircularProgress } from "@mui/material";
import { Helper } from "../../tools/Helper";
import { api_Routes } from "../../tools/api_Routes";
import PanelHead from "../Panel/PanelHead";
import PanelBody from "../Panel/PanelBody";
import { errorToaster } from "../../helper/toasterConfiguration";

const SupportChat = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [isSendLoading, setIsSendLoading] = useState(false);
  const [data, setData] = useState([]);

  const getData = async () => {
    const { response, message } = await Helper.Get({
      url: api_Routes.Support.viewTicket + id,
      hasToken: true,
    });
    if (response) {
      setData(response.data);
    } else {
      console.log(message);
      errorToaster("Can't find this ticket");
      navigate("//Support");
    }
    setIsLoading(false);
    setIsSendLoading(false);
  };

  useEffect(() => {
    getData();

    const interval = setInterval(() => {
      getData();
    }, 30000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div>
      <PanelHead title={`Ticket #{${id}}`} />
      <PanelBody
        content={
          isLoading ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "calc(100dvh - 92px)",
              }}
            >
              <CircularProgress sx={{ color: "blue" }} />
            </Box>
          ) : (
            <Styles>
              <ChatComponent
                data={data}
                getData={getData}
                isSendLoading={isSendLoading}
                setIsSendLoading={setIsSendLoading}
              />
            </Styles>
          )
        }
      />
    </div>
  );
};

export default SupportChat;
